import DashboardSearch from "./DashboardSearch";

export default DashboardSearch;